<template>
  <div v-if="viewport" class="page-wrap">
    <banner :nav-index="5">
      <template slot="banner">
        <div class="banner">
          <div class="centre" :style="{'will-change':'transform',transform:`translate3d(0,${transLateY}px,0)`}">
            <div class="letter">
              <h1 class="conf-title"><span>BCI Developers Conference</span></h1>
              <div class="line"></div>
              <p class="desc top">Brain-Computer Interface Developers Conference (abbreviated as BCI Developers Conference) is a global industry developer summit for brain-computer interface (BCI) technologies and products, initiated by Beijing Maschine Robot Technology in 2023. It serves as a China-focused technical exchange platform dedicated to developers within the BCI sector. Centered on the BCI technology and product track, the conference builds an exchange ecosystem covering medical care, industry, academia, R&D practitioners, developers and capital around technological research, engineering practice and scenario development.The conference was launched in 2023, and has been successfully held in 2024 and 2025, with the 3rd session scheduled for August 2026. It is an annual professional exchange event for global practitioners across the BCI industry.</p>
<!--              <p class="desc top">由北京姬械机科技（Maschine Robot）于2023年发起的全球脑机接口技术与产品行业开发者大会，是国内脑机接口领域专注于开发者群体的技术交流平台。</p>
              <p class="desc">聚焦脑机接口技术与产品赛道，搭建贯通医疗、产业、学术、研发、开发者与资本的脑与智能技术发展交流平台。</p>-->
              <div class="frame-row">
                <div class="frame">Ignite · Reshape The Future</div>
                <div class="frame-logo-wrap">
                  <img class="frame-logo" src="@/assets/conference/image1-3.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </banner>

    <div style="position:relative;z-index:2;background-color:#fff">

      <!-- 大会简介 -->
      <section class="intro">
        <div class="centre-box">
          <div class="section-title">
            <h2>Conference Introduction</h2>
            <div class="line-bar"></div>
          </div>
          <div class="intro-content">
            <div class="intro-text">
              <p>The BCI Developers Conference is a China-based technical exchange event exclusively oriented to technical and application developers in the BCI industry. It primarily targets technical developers and application builders within the BCI sector, while also opening participation to industry managers and application developers from all sectors interested in BCI technologies and use cases.</p>
              <p class="mt20">The conference shares global progress and trends in BCI technology, covering multiple modules with technical briefings and R&D demonstrations: BCI product design, BCI hardware development, brain data construction, BCI AI algorithm research, brain-computer interactive applications, as well as safety and ethics of BCI deployment.</p>
              <p class="mt20">The conference aims to respond to the national strategy for scientific and technological development, promote the large-scale innovative application of brain-computer interface (BCI) technologies across various industrial scenarios, foster a BCI application industry integrating artificial intelligence and brain-computer interface technologies, further advance the transformation and practical implementation of new quality productive forces derived from cutting-edge brain-computer interaction technologies, and empower the development of relevant industries.</p>
              <div class="info-grid">
                <div class="info-item"><span class="label">Initiator</span><span class="value">Beijing Maschine Robot Technology</span></div>
                <div class="info-item"><span class="label">Year of Initiation</span><span class="value">2023</span></div>
                <div class="info-item"><span class="label">English Name</span><span class="value">BCI Developers Conference</span></div>
                <div class="info-item"><span class="label">Regular Schedule</span><span class="value">Annual official sessions starting from 2024</span></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 2023发起背景：Final Fantancy 三大趋势 -->
      <section class="fantancy">
        <div class="centre-box">
          <div class="section-title">
            <h2>Conference Background</h2>
            <div class="line-bar"></div>
<!--
            <p class="sub-title">姬械机科技于2023年通过脑机未来启示录——Final Fantancy，预测了人类未来的生活型态与文明形态将如何演变，并展示了从2026年到2326年300年间，人类生活变迁的5个场景。</p>
-->         <p class="sub-title">China’s domestic BCI industry entered its budding stage in 2018, witnessing rapid expansion and the emergence of numerous startups. After 2022, the sector stepped into a downward adjustment phase. Following market screening, only a dozen enterprises out of thousands of original startup teams continued relevant R&D work. The ups and downs of the industry reflect multiple practical challenges in the industrialization process of China’s cutting-edge technologies.</p>

            <p class="sub-title">Against this backdrop, Maschine Robot Technology set up a special industry technical development team for brain-computer research in 2023. By founding the BCI Developers Conference, the team aims to reignite industry attention to brain-computer interfaces, a cutting-edge technological field featuring brand-new interaction technology, fuel the booming development of the BCI industry, and raise the overall visibility of the sector, drive the commercialization of BCI technologies, and make brain-computer interfaces a vital component of new quality productive forces.</p>
            <h2>Past Sessions</h2>
            <div class="line-bar"></div>
            <p class="sub-title">Session Composition（2023）</p>
            <p class="sub-title">On June 6, 2023, the special project team for the BCI Developers Conference was formally established in Beijing under the theme "Building the Industrial Ecosystem for Brain and Intelligent Technologies". The team also released the revelations on the future of Brain-Computer Interfaces: Final Fantacy.
              The publication envisions the application and evolution of BCI technologies in human society and civilization. Through open-source industry activities organized by the BCI Developers Conference, professionals, BCI startups and market capital institutions from all industries can gain comprehensive, in-depth insights into BCI technical routes and application solutions, jointly advancing technological progress, industrial development and commercialization of brain-computer interfaces.
            </p>
            <h2>Three Core Trends Proposed in Final Fantasy</h2>
            <div class="line-bar"></div>
          </div>
          <div class="trend-list">
            <div class="trend-item">
              <div class="trend-text">
                <p class="trend-num">Trend 1</p>
                <p class="trend-desc">With humanity’s five traditional senses fully explored and utilized, brain-computer interfaces unlock a new frontier: humanity’s sixth sense.</p>
              </div>
              <img class="trend-img" src="@/assets/conference/image2-1.png" alt="趋势1">
            </div>
            <div class="trend-item">
              <div class="trend-text">
                <p class="trend-num">Trend 2</p>
                <p class="trend-desc">Human-computer interaction will break free from 2D flat interfaces, connecting directly to the human brain. This will trigger revolutionary shifts in information transmission and storage, alongside a full upgrade of interactive experiences.</p>
              </div>
              <img class="trend-img" src="@/assets/conference/image3-1.png" alt="趋势2">
            </div>
            <div class="trend-item">
              <div class="trend-text">
                <p class="trend-num">Trend 3</p>
                <p class="trend-desc">Human civilization will expand beyond Earth and evolve into a multi-planetary civilization.</p>
              </div>
              <img class="trend-img trend-img-contain" src="@/assets/conference/image4-1.png" alt="趋势3">
            </div>
          </div>
          <div class="scene-caption">Building on these three trends, Maschine Robot Technology predicted shifts in human lifestyles and civilization evolution, showcasing five distinct life scenarios spanning 300 years from 2026 to 2326.</div>
          <div class="scene-wrap">
            <img src="@/assets/conference/image5-1.png" alt="2026-2326年人类生活变迁5个场景">
          </div>
        </div>
      </section>

      <!-- 第一届大会 2024 -->
      <section class="edition-section ed1">
        <div class="centre-box">
          <div class="section-title">
            <span class="year-badge">2024</span>
            <h2>Session 1: The 1st BCI Developers Conference</h2>
            <div class="line-bar"></div>
            <p class="meta-line">2024/8/16 &nbsp;·&nbsp; Beijing</p>
<!--            <p class="sub-title">主题：Ignite · Reshape The Future。面向脑机接口行业技术人员、高校学生、研究人员、创业公司、政府及投资方等多类群体开放，旨在让各界从更全面深入的角度理解脑机接口技术路线与应用方案。</p>
            --><p class="sub-title">Following program design and project initiation in 2023, the inaugural BCI Developers Conference, hosted by Beijing Maschine Robot Technology, opened in Beijing on August 16, 2024. The event adopted the slogan Ignite-Reshape The Future. Its goal was to help cross-industry practitioners, BCI specialists and startups gain holistic understanding of BCI technical paths and application solutions. Attendees included university students, researchers, startup founders, industry clients, tech enthusiasts, government representatives and investors.</p>
          </div>
          <div class="kv-agenda">
            <img class="kv-img" src="@/assets/conference/image7.png" alt="第一届大会主视觉">
            <img class="agenda-img" src="@/assets/conference/image8-1.png" alt="第一届会议日程">
          </div>
          <div class="photo-grid-4">
            <img src="@/assets/conference/image9-1.jpeg" alt="">
            <img src="@/assets/conference/image10-1.jpeg" alt="">
            <img src="@/assets/conference/image11-1.jpeg" alt="">
            <img src="@/assets/conference/image12-1.jpeg" alt="">
          </div>
        </div>
      </section>

      <!-- 第二届大会 2025 -->
      <section class="edition-section ed2">
        <div class="centre-box">
          <div class="section-title">
            <span class="year-badge">2025</span>
            <h2>Session 2: The 2nd BCI Developers Conference</h2>
            <div class="line-bar"></div>
            <p class="meta-line">2025/8/16—2025/8/17 &nbsp;·&nbsp; Chengdu Jinjiang</p>
<!--            <p class="sub-title">邀请来自MIT、清华大学、北京大学、北京师范大学、中科院自动化所、华南理工大学、电子科技大学等机构的知名研究学者，以及多位产业技术专家进行主题报告，涵盖脑机接口技术与应用、类脑智能、俱身智能等方向，吸引近千名参会人员。</p>
            --><p class="sub-title">Hosted by Maschine Robot Technology, the 2nd BCI Developers Conference took place in Jinjiang, Chengdu, on August 16–17, 2025. Centered on brain and intelligent technologies, the summit invited over a dozen leading academic scholars from MIT, Tsinghua University, Peking University, Beijing Normal University, Institute of Automation of Chinese Academy of Sciences, South China University of Technology and University of Electronic Science and Technology of China, alongside industry technical experts and tech leaders, delivering more than ten thematic briefings on technology and industry. The event attracted nearly 1,000 participants. Conference presentations covered BCI technologies and applications, brain-inspired intelligence technologies and applications, as well as embodied brain-inspired intelligence technologies and use cases.</p>

          </div>
          <div class="agenda-full">
            <img src="@/assets/conference/image13-3.jpeg" alt="第二届大会完整议程">
          </div>
          <div class="ed2-row">
            <img src="@/assets/conference/image18-1.png" alt="会场全景">
            <img src="@/assets/conference/image19-1.png" alt="集体合影">
          </div>
          <div class="ed2-row">
            <img src="@/assets/conference/image17-1.png" alt="入场签到">
            <img src="@/assets/conference/image14-1.png" alt="展区前台">
            <img src="@/assets/conference/image15-1.png" alt="展柜陈列">
          </div>
          <div class="ed2-full">
            <img src="@/assets/conference/image16-1.png" alt="大会出版物">
          </div>
        </div>
      </section>

      <!-- 第三届预告 -->
      <section class="upcoming">
        <div class="centre-box">
          <div class="upcoming-card">
            <div class="upcoming-left">
              <span class="year-badge light">2026</span>
              <h2>Session 3: The 3rd BCI Developers Conference</h2>
              <p class="meta-line-light">2026/8 &nbsp;Shanghai </p>
              <p class="upcoming-desc">The 3rd BCI Developers Conference will be held in August 2026, themed "Large-Scale Commercialization of BCI Technologies and Products". Focused on brain and intelligent technologies, it will organize exchanges and seminars covering technology R&D, engineering practice, product development and scenario deployment, building a technical and engineering communication platform for global BCI developers.</p>
              <div class="upcoming-slogan">Ignite · Reshape The Future</div>
            </div>

          </div>
        </div>
      </section>

      <!-- 合作单位 -->
      <section class="partners">
        <div class="partners-inner">
          <h2>Partners</h2>
          <div class="partners-grid">
            <div class="partner-item">
              <div class="partner-logo"><img src="@/assets/harmonize.png"></div>
              <p>Peking Union Medical College Hospital</p>
            </div>
            <div class="partner-item">
              <div class="partner-logo"><img src="@/assets/zheda.png"></div>
              <p>Zhejiang University</p>
            </div>
            <div class="partner-item">
              <div class="partner-logo"><img src="@/assets/dianzi.png"></div>
              <p>UESTC</p>
            </div>
            <div class="partner-item">
              <div class="partner-logo"><img src="@/assets/jd-university.png"></div>
              <p>Shanghai Jiao Tong University</p>
            </div>
            <div class="partner-item">
              <div class="partner-logo"><img src="@/assets/Stanford.png"></div>
              <p>Stanford University</p>
            </div>
            <div class="partner-item">
              <div class="partner-logo dianzi.png"><img src="@/assets/mit.png"></div>
              <p>MIT</p>
            </div>
          </div>
        </div>
      </section>

      <relation></relation>
    </div>
  </div>

  <!-- 手机端 -->
  <div v-else class="phone-wrap">
    <div class="ph-background">
      <div class="ph-nav">
        <div class="ph-logo"><img src="@/assets/phone/phone-logo.png"></div>
        <div @click="onList" class="ph-fork"><span class="iconfont icon-liebiaoshitucaidan"></span></div>
      </div>
      <div class="ph-hero">
        <img class="ph-conf-logo" src="@/assets/conference/image1.png" alt="脑机接口开发者大会">
        <div class="ph-line"></div>
        <p class="ph-sub">Brain-Computer Interface Developers Conference (abbreviated as BCI Developers Conference) is a global industry developer summit for brain-computer interface (BCI) technologies and products, initiated by Beijing Maschine Robot Technology in 2023. It serves as a China-focused technical exchange platform dedicated to developers within the BCI sector. Centered on the BCI technology and product track, the conference builds an exchange ecosystem covering medical care, industry, academia, R&D practitioners, developers and capital around technological research, engineering practice and scenario development.The conference was launched in 2023, and has been successfully held in 2024 and 2025, with the 3rd session scheduled for August 2026. It is an annual professional exchange event for global practitioners across the BCI industry.</p>
        <div class="ph-slogan">Ignite · Reshape The Future</div>
      </div>
      <div v-show="list" class="ph-list"><phoneNav @onHide="onHide"></phoneNav></div>
    </div>

    <div class="ph-section">
      <h2>Conference Introduction</h2>
      <div class="ph-divider"></div>
      <p>The BCI Developers Conference is a China-based technical exchange event exclusively oriented to technical and application developers in the BCI industry. It primarily targets technical developers and application builders within the BCI sector, while also opening participation to industry managers and application developers from all sectors interested in BCI technologies and use cases.
        The conference shares global progress and trends in BCI technology, covering multiple modules with technical briefings and R&D demonstrations: BCI product design, BCI hardware development, brain data construction, BCI AI algorithm research, brain-computer interactive applications, as well as safety and ethics of BCI deployment.
        The conference aims to respond to the national strategy for scientific and technological development, promote the large-scale innovative application of brain-computer interface (BCI) technologies across various industrial scenarios, foster a BCI application industry integrating artificial intelligence and brain-computer interface technologies, further advance the transformation and practical implementation of new quality productive forces derived from cutting-edge brain-computer interaction technologies, and empower the development of relevant industries.
      </p>
    </div>

    <div class="ph-section dark">
      <h2 class="light">Conference Background</h2>
      <div class="ph-divider white"></div>
      <p class="ph-light-text">China’s domestic BCI industry entered its budding stage in 2018, witnessing rapid expansion and the emergence of numerous startups. After 2022, the sector stepped into a downward adjustment phase. Following market screening, only a dozen enterprises out of thousands of original startup teams continued relevant R&D work. The ups and downs of the industry reflect multiple practical challenges in the industrialization process of China’s cutting-edge technologies.</p>
      <p class="ph-light-text mt20">Against this backdrop, Maschine Robot Technology set up a special industry technical development team for brain-computer research in 2023. By founding the BCI Developers Conference, the team aims to reignite industry attention to brain-computer interfaces, a cutting-edge technological field featuring brand-new interaction technology, fuel the booming development of the BCI industry, and raise the overall visibility of the sector, drive the commercialization of BCI technologies, and make brain-computer interfaces a vital component of new quality productive forces.</p>
      <div class="ph-trend-card mt20">
        <p class="ph-trend-num">Trend 1</p>
        <p class="ph-trend-desc">With humanity’s five traditional senses fully explored and utilized, brain-computer interfaces unlock a new frontier: humanity’s sixth sense.</p>
        <img class="ph-full-img mt12" src="@/assets/conference/image2-1.png" alt="Trend 1">
      </div>
      <div class="ph-trend-card mt20">
        <p class="ph-trend-num">Trend 2</p>
        <p class="ph-trend-desc">Human-computer interaction will break free from 2D flat interfaces, connecting directly to the human brain. This will trigger revolutionary shifts in information transmission and storage, alongside a full upgrade of interactive experiences.</p>
        <img class="ph-full-img mt12" src="@/assets/conference/image3-1.png" alt="Trend 2">
      </div>
      <div class="ph-trend-card mt20">
        <p class="ph-trend-num">Trend 3</p>
        <p class="ph-trend-desc">Human civilization will expand beyond Earth and evolve into a multi-planetary civilization.</p>
        <img class="ph-full-img ph-trend-contain mt12" src="@/assets/conference/image4-1.png" alt="Trend 3">
      </div>
      <p class="ph-light-text mt20">Building on these three trends, Maschine Robot Technology predicted shifts in human lifestyles and civilization evolution, showcasing five distinct life scenarios spanning 300 years from 2026 to 2326.</p>
      <img class="ph-full-img mt12" src="@/assets/conference/image5-1.png" alt="Five life scenarios from 2026 to 2326">
    </div>

    <div class="ph-section">
      <div class="ph-year-row"><span class="ph-year">2024</span><span class="ph-tag">Session 1</span></div>
      <h2>The 1st BCI Developers Conference</h2>
      <div class="ph-divider"></div>
      <p class="ph-meta">2024/8/1 · Beijing</p>
      <img class="ph-full-img mt12" src="@/assets/conference/image7.png" alt="">
      <img class="ph-full-img mt12" src="@/assets/conference/image8-1.png" alt="第一届日程">
      <div class="ph-photo-grid">
        <img src="@/assets/conference/image9-1.jpeg" alt="">
        <img src="@/assets/conference/image10-1.jpeg" alt="">
        <img src="@/assets/conference/image11-1.jpeg" alt="">
        <img src="@/assets/conference/image12-1.jpeg" alt="">
      </div>
    </div>

    <div class="ph-section dark">
      <div class="ph-year-row"><span class="ph-year light">2025</span><span class="ph-tag light">Session 2</span></div>
      <h2 class="light">The 2nd BCI Developers Conference</h2>
      <div class="ph-divider white"></div>
      <p class="ph-meta light">2025/8/16—2025/8/17 · Chengdu Jinjiang</p>
      <img class="ph-full-img mt12" src="@/assets/conference/image13-3.jpeg" alt="第二届议程">
      <div class="ph-photo-grid">
        <img src="@/assets/conference/image18-1.png" alt="">
        <img src="@/assets/conference/image17-1.png" alt="">
        <img src="@/assets/conference/image14-1.png" alt="">
        <img src="@/assets/conference/image15-1.png" alt="">
      </div>
      <img class="ph-full-img mt12" src="@/assets/conference/image19-1.png" alt="第二届合影">
      <img class="ph-full-img" src="@/assets/conference/image16-1.png" alt="大会出版物">
    </div>


    <div class="ph-section bg-light">
      <h2>Partners</h2>
      <div class="ph-divider"></div>
      <div class="partners-inner">
        <div class="partners-grid">
          <div class="partner-item">
            <div class="partner-logo"><img src="@/assets/harmonize.png" alt="Peking Union Medical College Hospital"></div>
            <p>Peking Union Medical College Hospital</p>
          </div>
          <div class="partner-item">
            <div class="partner-logo"><img src="@/assets/zheda.png" alt="Zhejiang University"></div>
            <p>Zhejiang University</p>
          </div>
          <div class="partner-item">
            <div class="partner-logo"><img src="@/assets/dianzi.png" alt="UESTC"></div>
            <p>UESTC</p>
          </div>
          <div class="partner-item">
            <div class="partner-logo"><img src="@/assets/jd-university.png" alt="Shanghai Jiao Tong University"></div>
            <p>Shanghai Jiao Tong University</p>
          </div>
          <div class="partner-item">
            <div class="partner-logo"><img src="@/assets/Stanford.png" alt="Stanford University"></div>
            <p>Stanford University</p>
          </div>
          <div class="partner-item">
            <div class="partner-logo dianzi.png"><img src="@/assets/mit.png" alt="MIT"></div>
            <p>MIT</p>
          </div>
        </div>
      </div>
    </div>

    <div class="ph-upcoming">
      <img class="ph-conf-logo small" src="@/assets/conference/image1.png" alt="">
      <h2>Session 3: The 3rd BCI Developers Conference</h2>
      <p class="ph-meta light">2026/8 · Shanghai</p>
      <p class="ph-light-text mt12">The 3rd BCI Developers Conference will be held in August 2026, themed "Large-Scale Commercialization of BCI Technologies and Products". Focused on brain and intelligent technologies, it will organize exchanges and seminars covering technology R&D, engineering practice, product development and scenario deployment, building a technical and engineering communication platform for global BCI developers.</p>
      <div class="ph-slogan">Ignite · Reshape The Future</div>
    </div>

    <phoneFooter></phoneFooter>
  </div>
</template>

<script>
import banner from '@/components/banner'
import relation from '@/components/footer'
import phoneNav from '@/components/phoneNav/index'
import phoneFooter from '@/components/phoneFooter'

export default {
  name: 'conference',
  components: { banner, relation, phoneNav, phoneFooter },
  data() {
    return {
      toTop: 0,
      transLateY: 0,
      viewport: true,
      screenWidth: null,
      list: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.screenWidth = document.body.clientWidth
    if (document.documentElement.clientWidth < 1280) this.viewport = false
    window.onresize = () => { this.screenWidth = document.body.clientWidth }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  watch: {
    screenWidth(n) { this.viewport = n > 1024 }
  },
  methods: {
    onList() { setTimeout(() => { this.list = true }, 200) },
    onHide() { setTimeout(() => { this.list = false }, 200) },
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop < 900) {
        this.transLateY = this.toTop <= scrollTop ? scrollTop / 10 : -scrollTop / 10
      }
      this.toTop = scrollTop
    }
  }
}
</script>

<style scoped>
/* ===== 桌面端 ===== */
.banner { min-height: 900px; }

.banner .centre {
  width: 1200px;
  min-height: 900px;
  margin: 0 auto;
  padding-top: 120px;
  padding-bottom: 80px;
}

.banner .centre .letter { flex: 1; }

.conf-title {
  color: #FFFFFF;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 600;
  font-size: 54px;
  line-height: 76px;
  letter-spacing: 2px;
}
.conf-title span {
  display: block;
}

.banner .centre .letter .line {
  margin-top: 60px;
  width: 60px;
  height: 6px;
  background-color: #FFFFFF;
}

.banner .centre .letter .desc {
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 36px;
  color: #FFFFFF;
  letter-spacing: 1px;
  opacity: 0.8;
}
.banner .centre .letter .top { margin-top: 42px; padding-bottom: 0; }

.banner .centre .letter .frame {
  margin-top: 0;
  padding: 0 0;
  height: 100px;
  width: fit-content;
  white-space: nowrap;
  font-weight: 600;
  font-size: 28px;
  display: flex;
  align-items: center;
  border-top: 1px solid #FFFFFF;
  border-bottom: 1px solid #FFFFFF;
  color: #FFFFFF;
  font-family: 'PingFang SC';
}

.frame-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 50px;
}

.frame-row .frame {
  margin-top: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.frame-logo-wrap {
  line-height: 0;
}

.frame-logo {
  height: 100px;
  width: auto;
  flex-shrink: 0;
}

.banner-kv {
  flex: 0 0 500px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: 20px;
}
.banner-kv img {
  width: 480px;
  border-radius: 8px;
  opacity: 0.88;
}

/* 通用 */
.centre-box { width: 1200px; margin: 0 auto; }

.section-title { margin-bottom: 48px; }
.section-title h2 {
  font-size: 40px;
  font-weight: 600;
  color: #111111;
  font-family: 'PingFang SC';
  margin-bottom: 18px;
  margin-top: 12px;
}
.line-bar { width: 48px; height: 5px; background-color: #111111; margin-bottom: 24px; }
.sub-title { font-size: 17px; line-height: 32px; color: #555555; width: 100%; font-family: 'PingFang SC'; }
.meta-line { font-size: 16px; color: #777777; margin-bottom: 14px; font-family: 'PingFang SC'; }
.year-badge {
  display: inline-block;
  font-size: 13px;
  font-weight: 600;
  color: #FFFFFF;
  background: linear-gradient(135deg, #545f65, #8cafb8);
  padding: 3px 14px;
  border-radius: 20px;
  margin-bottom: 12px;
  letter-spacing: 1px;
  font-family: 'PingFang SC';
}

/* 大会简介 */
.intro { padding: 90px 0 80px; }
.intro-text p { font-size: 17px; line-height: 32px; color: #444444; font-family: 'PingFang SC'; }
.mt20 { margin-top: 20px; }
.info-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1px;
  margin-top: 48px;
  background: #E8ECF0;
  border: 1px solid #E8ECF0;
}
.info-item {
  display: flex;
  flex-direction: column;
  padding: 24px 28px;
  background: #FFFFFF;
}
.info-item .label { font-size: 13px; color: #999999; margin-bottom: 8px; }
.info-item .value { font-size: 16px; font-weight: 500; color: #111111; line-height: 1.5; white-space: nowrap; }

/* Final Fantancy */
.fantancy { padding: 80px 0 90px; background: #F0F3F5; }
.fantancy .section-title h2 { color: #111111; }
.trend-list { display: flex; gap: 32px; margin-bottom: 40px; }
.trend-item { flex: 1; display: flex; flex-direction: column; }
.trend-text { flex: 1; padding: 16px 0 12px; }
.trend-num { font-weight: 600; font-size: 18px; color: #111111; margin-bottom: 8px; }
.trend-desc { font-size: 14px; line-height: 24px; color: #444444; }
.trend-img { width: 100%; height: auto; border-radius: 4px; display: block; }
.trend-img-contain { height: 104px; width: 100%; object-fit: contain; }
.scene-caption { font-size: 16px; line-height: 30px; color: #444444; margin-bottom: 16px; }
.scene-wrap { margin-top: 8px; }
.scene-wrap img {
  width: 100%;
  display: block;
  border-radius: 4px;
  mix-blend-mode: multiply;
}

/* 历届大会通用 */
.edition-section { padding: 80px 0 90px; }
.ed1 { background: #FFFFFF; }
.ed2 { background: #F0F3F5; }

.kv-agenda { display: flex; gap: 12px; margin-bottom: 12px; align-items: center; }
.kv-img { height: 555px; width: auto; border-radius: 6px; flex: none; }
.agenda-img { height: 555px; width: auto; border-radius: 6px; flex: none; }

.photo-grid-4 { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; }
.photo-grid-4 img { width: 100%; border-radius: 4px; object-fit: cover; aspect-ratio: 4/3; }

.agenda-full { margin-bottom: 12px; }
.agenda-full img { width: 100%; border-radius: 6px; }
.ed2-full { margin-bottom: 12px; }
.ed2-full img { width: 100%; border-radius: 6px; display: block; }
.ed2-row { display: flex; gap: 12px; margin-bottom: 12px; align-items: stretch; }
.ed2-row img { flex: 1; width: 0; border-radius: 6px; object-fit: cover; }

.photo-grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.photo-grid-3 img { width: 100%; border-radius: 4px; object-fit: cover; aspect-ratio: 4/3; }
.photo-grid-3 .span2 { grid-column: span 2; aspect-ratio: 8/3; }

/* 出版物 */
.publications { padding: 80px 0; background: #FFFFFF; }
.pub-img-wrap img { width: 100%; max-width: 900px; display: block; margin: 0 auto; }

/* 合作单位 */
.partners {
  padding: 100px 0;
  background: #FFFFFF;
}
.partners-inner {
  width: 1200px;
  margin: 0 auto;
  background: #F0F3F5;
  border-radius: 12px;
  padding: 60px 80px;
  box-sizing: border-box;
}
.partners-inner h2 {
  margin-bottom: 50px;
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 60px;
  color: #111111;
}
.partners-grid {
  display: flex;
  justify-content: space-between;
}
.partner-item {
  width: 160px;
  height: 200px;
  padding: 25px 12px;
  box-sizing: border-box;
  background-color: #FFFFFF;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.partner-logo {
  width: 100%;
  height: 92px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.partner-logo img {
  width: auto;
  height: 74px;
  max-width: 100%;
  object-fit: contain;
  display: block;
}
.partner-item p {
  margin-top: 12px;
  text-align: center;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #111111;
}

/* 第三届预告 */
.upcoming {
  padding: 80px 0 90px;
  background: #FFFFFF;
}
.upcoming-card {
  display: block;
  padding: 0;
  background: transparent;
}
.upcoming-left { width: 100%; }
.upcoming-left h2 {
  font-size: 40px;
  font-weight: 600;
  color: #111111;
  margin: 12px 0 18px;
}
.meta-line-light {
  font-size: 16px;
  color: #777777;
  margin-bottom: 14px;
}
.upcoming-desc {
  font-size: 17px;
  line-height: 32px;
  color: #555555;
  width: 100%;
}
.upcoming-slogan {
  margin-top: 40px;
  padding: 14px 0;
  font-size: 26px;
  font-weight: 600;
  color: #111111;
  border-top: 1px solid rgba(0,0,0,0.25);
  border-bottom: 1px solid rgba(0,0,0,0.25);
  display: inline-block;
  min-width: 400px;
}
.upcoming-right img { height: 100px; mix-blend-mode: screen; opacity: 0.9; }
.year-badge.light { background: linear-gradient(135deg, #545f65, #8cafb8); }
.line-bar.light { background-color: #111111; }

/* ===== 手机端 ===== */
.phone-wrap { font-family: 'PingFang SC'; }

.ph-background {
  background-image: linear-gradient(to bottom right, #545f65, #814e54);
  padding-bottom: 1.5rem;
}
.ph-nav { display: flex; justify-content: space-between; padding: 1.14rem 0.6rem 0; }
.ph-logo { display: flex; align-items: center; height: 0.43rem; }
.ph-logo img { height: 0.35rem; }
.ph-fork { height: 0.43rem; line-height: 0.43rem; color: #FFFFFF; }
.ph-fork .iconfont { font-size: 0.36rem; }

.ph-hero { padding: 1rem 0.6rem 0; }
.ph-conf-logo { height: 0.9rem; mix-blend-mode: screen; }
.ph-conf-logo.small { height: 0.65rem; mix-blend-mode: screen; opacity: 0.85; }
.ph-line { margin: 0.4rem 0 0.3rem; width: 0.24rem; height: 0.03rem; background-color: #FFFFFF; }
.ph-sub { font-size: 0.24rem; line-height: 0.42rem; color: rgba(255,255,255,0.85); width: 5.6rem; }
.ph-slogan {
  margin-top: 0.5rem;
  font-size: 0.26rem;
  font-weight: 600;
  color: #FFFFFF;
  padding: 0.18rem 0;
  border-top: 1px solid rgba(255,255,255,0.4);
  border-bottom: 1px solid rgba(255,255,255,0.4);
  display: inline-block;
}
.ph-list { width: 100%; position: fixed; top: 0; left: 0; z-index: 9; }

.ph-section { padding: 0.8rem 0.6rem; background: #FFFFFF; }
.ph-section.dark { background: linear-gradient(135deg, #545f65 0%, #8cafb8 100%); }
.ph-section.bg-light { background: #F0F3F5; }
.phone-wrap .partners-inner { width: 100%; }
.phone-wrap .partners-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.2rem;
}
.phone-wrap .partner-item {
  width: auto;
  height: 2.2rem;
  padding: 0.18rem;
  justify-content: flex-start;
}
.phone-wrap .partner-logo {
  width: 100%;
  height: 1rem;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.phone-wrap .partner-logo img {
  width: auto;
  height: 0.78rem;
  max-width: 100%;
  object-fit: contain;
  display: block;
}
.phone-wrap .partner-item p {
  margin-top: 0.14rem;
  font-size: 0.2rem;
  line-height: 0.28rem;
  text-align: center;
}
.ph-section h2 { font-size: 0.34rem; font-weight: 600; color: #111111; margin-bottom: 0.24rem; }
.ph-section h2.light { color: #FFFFFF; }
.ph-divider { width: 0.4rem; height: 0.04rem; background: #111111; margin-bottom: 0.36rem; }
.ph-divider.white { background: rgba(255,255,255,0.6); }
.ph-section p { font-size: 0.24rem; line-height: 0.44rem; color: #444444; }
.ph-light-text { font-size: 0.24rem; line-height: 0.44rem; color: rgba(255,255,255,0.85); }
.ph-trend-card {
  padding: 0.28rem;
  border-radius: 0.08rem;
  background: rgba(255, 255, 255, 0.12);
}
.ph-trend-num {
  font-size: 0.26rem;
  line-height: 0.36rem;
  font-weight: 600;
  color: #FFFFFF;
}
.ph-trend-desc {
  margin-top: 0.08rem;
  font-size: 0.23rem;
  line-height: 0.4rem;
  color: rgba(255, 255, 255, 0.86);
}
.ph-trend-contain {
  object-fit: contain;
  background: rgba(255, 255, 255, 0.1);
}
.ph-full-img { width: 100%; border-radius: 0.06rem; display: block; }
.mt12 { margin-top: 0.2rem; }
.ph-photo-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0.12rem; margin-top: 0.2rem; }
.ph-photo-grid img { width: 100%; border-radius: 0.06rem; object-fit: cover; aspect-ratio: 4/3; }
.ph-meta { font-size: 0.22rem; color: #888888; margin-bottom: 0.1rem; }
.ph-meta.light { color: rgba(255,255,255,0.65); }
.ph-year-row { display: flex; align-items: baseline; gap: 0.16rem; margin-bottom: 0.16rem; }
.ph-year { font-size: 0.42rem; font-weight: 700; color: #111111; }
.ph-year.light { color: #FFFFFF; }
.ph-tag { font-size: 0.2rem; color: #666; border: 1px solid #CCC; padding: 0.02rem 0.14rem; border-radius: 0.2rem; }
.ph-tag.light { color: rgba(255,255,255,0.8); border-color: rgba(255,255,255,0.4); }

.ph-upcoming {
  padding: 0.9rem 0.6rem 1rem;
  background: linear-gradient(to top left, #814e54, #545f65, #8cafb8);
}
.ph-upcoming h2 { font-size: 0.34rem; font-weight: 600; color: #FFFFFF; margin: 0.3rem 0 0.1rem; }
</style>